import { IEventrHotel } from '@eventr/common'
import { useMemo } from 'react'
import { useScreenTypeContext } from '../state/screenTypeProvider'
import { useMatchTagsAndUsers } from './hooks/useMatchTagsAndUsers'
import { HotelAddress } from './hotelComponents/hotelAddress'
import { HotelBookingInfo } from './hotelComponents/hotelBookingInfo'
import { HotelHeader } from './hotelComponents/hotelHeader'
import { ObjectProvider } from './providers/objectProvider'
import { BaseCard } from './subComponents/baseCard'

interface HotelCardProps {
    id: string
    data?: IEventrHotel
    past?: boolean
    border?: boolean
}

export const HotelCard = ({ id, data, past = false }: HotelCardProps) => {
    const { screenType } = useScreenTypeContext()
    const { matchTagsAndUser } = useMatchTagsAndUsers()

    const room = useMemo(() => {
        if ((data?.rooms?.length ?? 0) === 0) {
            return undefined
        }
        return data?.rooms?.find((room) => {
            return room?.guests?.some((user) => {
                return matchTagsAndUser(user)
            })
        })
    }, [data?.rooms, matchTagsAndUser])

    if (!data) return null

    const attachments = {
        notes: data.notes,
        extra_docs: data.extra_docs,
        website: data.website,
        phoneNumber: data.telephoneNumber,
        contactName: data.contactName,
    }

    return (
        <ObjectProvider past={past} _id={data._id ?? ''} sectionID="3">
            {screenType === 'upNext' ? (
                <BaseCard id={id} past={past}>
                    <HotelHeader
                        name={data.name}
                        room={room}
                        label={data.label ?? ''}
                        labelTime={data.labelTime}
                    />
                    {data.OSMAddress && (
                        <HotelAddress address={data.OSMAddress} />
                    )}
                    <HotelBookingInfo
                        attachments={attachments}
                        rooms={data.rooms}
                        room={room}
                        chatNames={[data.name]}
                        providerData={(data as any).hotelProvider}
                    />
                </BaseCard>
            ) : screenType === 'edit' ? (
                <BaseCard id={id} past={past}>
                    <HotelHeader
                        name={data.name}
                        room={room}
                        label={data.label ?? ''}
                    />
                    {data.OSMAddress && (
                        <HotelAddress address={data.OSMAddress} />
                    )}
                    <HotelBookingInfo
                        attachments={attachments}
                        rooms={data.rooms}
                        room={room}
                        chatNames={[data.name]}
                    />
                </BaseCard>
            ) : screenType === 'personal' ? (
                <BaseCard id={id} past={past}>
                    <HotelHeader
                        name={data.name}
                        room={room}
                        label={data.label ?? ''}
                    />
                    {data.OSMAddress && (
                        <HotelAddress address={data.OSMAddress} />
                    )}
                    <HotelBookingInfo
                        attachments={attachments}
                        rooms={data.rooms}
                        room={room}
                        chatNames={[data.name]}
                    />
                </BaseCard>
            ) : screenType === 'team' || screenType === 'teamMember' ? (
                <BaseCard id={id} past={past}>
                    <HotelHeader
                        name={data.name}
                        room={room}
                        label={data.label ?? ''}
                    />
                    {data.OSMAddress && (
                        <HotelAddress address={data.OSMAddress} />
                    )}
                    <HotelBookingInfo
                        attachments={attachments}
                        rooms={data.rooms}
                        room={room}
                        chatNames={[data.name]}
                    />
                </BaseCard>
            ) : null}
        </ObjectProvider>
    )
}
